var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.9189,
    width: 6.08108,
    height: 26.6892,
    rx: 3.04054,
    fill: "#CFCFCF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.45947,
    y: 6.75708,
    width: 6.08108,
    height: 19.9324,
    rx: 3.04054,
    fill: "#FFBA30"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 14.865,
    width: 6.08108,
    height: 11.8243,
    rx: 3.04054,
    fill: "#FFBA30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.298a963d149c248bd51b1bfe56f83768.svg";
export { ForwardRef as ReactComponent };